/* eslint-disable */
import listing from "@/apollo/suppliers/listing.gql";

export const state = () => ({
  list: [],
  loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 20 May 2024 | 11:20AM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 20 May 2024 | 11:20AM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 20 May 2024 | 11:36AM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  fetchListing({ commit }, payload) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.suppliersListing);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading
};
